module.exports = __webpack_public_path__ + "6619f02c90d6279c5cee05ca8f2944f2.png";